<section class="value-prop" id="solution">
  <div class="container">
    <div class="section-header">
      <span class="section-badge">La solution Wealthlane</span>
      <h2>Élargissez votre mission, multipliez vos revenus</h2>
      <p>Face à l'automatisation comptable, les experts-comptables doivent se réinventer. Wealthlane vous permet de proposer du conseil patrimonial à forte valeur ajoutée, naturellement.</p>
    </div>

    <div class="value-grid">
      <div class="value-card">
        <div class="value-icon">⚡</div>
        <h3>Génération instantanée</h3>
        <p>Importez simplement vos données comptables et l'IA génère automatiquement un bilan patrimonial complet et personnalisé en moins de 5 minutes</p>
        <div class="value-stat value-stat-gold">
          <img src="/images/landing/white-star.svg" alt="Star" class="star-icon">
          &lt; 5 min
        </div>
      </div>
      <div class="value-card">
        <div class="value-icon">💰</div>
        <h3>Double source de revenus</h3>
        <p>Facturez entre 2 000€ et 8 000€ par mission de conseil patrimonial et touchez également 1% de commission sur chaque placement réalisé via notre plateforme</p>
        <div class="value-stat value-stat-gold">
          <img src="/images/landing/white-star.svg" alt="Star" class="star-icon">
          15-20 missions
        </div>
      </div>
      <div class="value-card">
        <div class="value-icon">📈</div>
        <h3>Conversion naturelle</h3>
        <p>Étendez naturellement votre mission de conseil auprès de clients qui vous font déjà confiance sur leur comptabilité. Taux de conversion moyen entre 30% et 50%</p>
        <div class="value-stat value-stat-gold">
          <img src="/images/landing/white-star.svg" alt="Star" class="star-icon">
          30-50%
        </div>
      </div>
    </div>
  </div>
</section>

